<div class="tablenav hidden-print">
  <div class="pages" *ngIf="showPages() && !items">
    <!-- JS managable pagination-->
    <button class="btn_img btn_graygray btn_doubleprev"></button>
    <button class="btn_img btn_graygray btn_prevpage"></button>
    <span>{{'Page'|translate }}</span>
    <input type="text" class="curpage" value="1">
    <span>{{'of'|translate }}</span>
    <span class="pagescount">10</span>
    <button class="btn_img btn_graygray btn_nextpage"></button>
    <button class="btn_img btn_graygray btn_doublenext"></button>
    <div class="dropup dropclick" *ngIf="viewmode.indexOf('hideitemscount') < 0">
      <input type="text" readonly="readonly" value="25">
      <ul>
        <li>5</li>
        <li>25</li>
        <li>50</li>
        <li>100</li>
        <li>500</li>
        <li>1000</li>
        <li>5000</li>
      </ul>
    </div>
  </div>

  <div class="pages" *ngIf="showPages() && items">
    <!-- TS managable pagination-->
    <button class="btn_img btn_graygray btn_doubleprev" (click)="firstPage()"></button>
    <button class="btn_img btn_graygray btn_prevpage" (click)="prevPage()"></button>

    <span>{{'Page'|translate }}</span>
    <input type="text" class="curpage" [(ngModel)]="pageInfo.pageNumber">
    <span>{{'of'|translate }}</span>
    <span class="pagescount">{{pagesCount}}</span>

    <button class="btn_img btn_graygray btn_nextpage" (click)="nextPage()"></button>
    <button class="btn_img btn_graygray btn_doublenext" (click)="lastPage()"></button>

    <div class="dropup dropclick" *ngIf="viewmode.indexOf('hideitemscount') < 0">
      <input type="text" readonly="readonly" [(ngModel)]="pageInfo.itemsPerPage">
      <ul>
        <li (click)="setItemsPerPage(5)">5</li>
        <li (click)="setItemsPerPage(25)">25</li>
        <li (click)="setItemsPerPage(50)">50</li>
        <li (click)="setItemsPerPage(100)">100</li>
        <li (click)="setItemsPerPage(500)">500</li>
        <li (click)="setItemsPerPage(1000)">1000</li>
        <li (click)="setItemsPerPage(5000)">5000</li>
        <li (click)="setItemsPerPage(10000000)">1000000</li>
      </ul>
    </div>
  </div>
  <div style="display:flex;">
    <button class="btn_img btn_graygray btn_noeye" *ngIf="showHideEmpty()"></button>
    <button class="btn_img btn_graygray btn_excel" (click)="excelExport()" *ngIf="showExcel()"></button>
    <button class="btn_img btn_graygray btn_print" (click)="pdfExport()" *ngIf="showPrint()"></button>

    <ng-content select="[export]"></ng-content>
  </div>
</div>
